import { useEffect } from 'react';

/**
 * Custom hook for keyboard shortcuts
 * Manages global keyboard event listeners
 */
export const useKeyboardShortcuts = (shortcuts) => {
  useEffect(() => {
    const handleKeyPress = (event) => {
      // Check if user is typing in an input field
      const isTyping = ['INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName);
      if (isTyping) return;

      const key = event.key.toLowerCase();
      const ctrl = event.ctrlKey || event.metaKey;
      const shift = event.shiftKey;
      const alt = event.altKey;

      // Build shortcut key combination
      const combination = `${ctrl ? 'ctrl+' : ''}${shift ? 'shift+' : ''}${alt ? 'alt+' : ''}${key}`;

      // Find and execute matching shortcut
      const shortcut = shortcuts.find(s => s.key === combination);
      if (shortcut) {
        event.preventDefault();
        shortcut.action();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [shortcuts]);
};

/**
 * Default keyboard shortcuts for Bible Study app
 */
export const getDefaultShortcuts = (language) => {
  return [
    { key: 'ctrl+b', name: language === 'es' ? 'Centro de Estudio' : 'Bible', description: language === 'es' ? 'Abrir Centro de Estudio' : 'Open Study Center' },
    { key: 'ctrl+c', name: language === 'es' ? 'Concordancia' : 'Concordance', description: language === 'es' ? 'Abrir Concordancia' : 'Open Concordance' },
    { key: 'ctrl+d', name: language === 'es' ? 'Diccionario' : 'Dictionary', description: language === 'es' ? 'Abrir Diccionario' : 'Open Dictionary' },
    { key: 'ctrl+m', name: language === 'es' ? 'Mapas' : 'Maps', description: language === 'es' ? 'Abrir Mapas Bíblicos' : 'Open Bible Maps' },
    { key: 'ctrl+n', name: language === 'es' ? 'Notas' : 'Notes', description: language === 'es' ? 'Abrir Mis Notas' : 'Open My Notes' },
    { key: 'ctrl+p', name: language === 'es' ? 'Planes' : 'Plans', description: language === 'es' ? 'Abrir Planes de Lectura' : 'Open Reading Plans' },
    { key: 'ctrl+h', name: language === 'es' ? 'Resaltados' : 'Highlights', description: language === 'es' ? 'Ver Resaltados' : 'View Highlights' },
    { key: 'ctrl+i', name: language === 'es' ? 'IA Compañero' : 'AI Companion', description: language === 'es' ? 'Abrir Compañero IA' : 'Open AI Companion' },
    { key: 'ctrl+shift+l', name: language === 'es' ? 'Diseño' : 'Layout', description: language === 'es' ? 'Personalizar Diseño' : 'Customize Layout' },
    { key: 'alt+l', name: language === 'es' ? 'Idioma' : 'Language', description: language === 'es' ? 'Cambiar Idioma' : 'Toggle Language' },
    { key: '?', name: language === 'es' ? 'Ayuda' : 'Help', description: language === 'es' ? 'Mostrar Atajos' : 'Show Shortcuts' }
  ];
};
